module.exports = __webpack_public_path__ + "static/media/ws.2690f3d8.svg";